<template>
  <div>
    <select v-model.number="selectedId">
      <option value="">-- 작품 선택 --</option>
      <option
        v-for="artwork in artworkList"
        :key="artwork.id"
        :value="artwork.id"
      >
        {{ artwork.themeSubject }} - {{ artwork.artist?.nameKo || 'Unknown Artist' }} ({{ artwork.id }})
      </option>
    </select>

    <a
      v-show="selectedId"
      :href="`https://article21.kr/artwork/${selectedId}`"
      target="_blank"
      style="display: inline-block; margin-top: 4px;"
    >
      작품 보기
    </a>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, defineProps, defineEmits } from 'vue';
import { apiClient } from '@/services/auth-header';

const artworkList = ref([]);

const props = defineProps({
  contentId: { type: [String, Number], default: '' },
});
const emit = defineEmits(['update:contentId']);

const selectedId = computed({
  get: () => props.contentId,
  set: (value) => emit('update:contentId', value),
});

const fetchArtworkList = async () => {
  try {
    const response = await apiClient.get('/contents/artworks');
    artworkList.value = response.data;
  } catch (error) {
    console.error('작품 목록 조회 실패:', error);
  }
};

onMounted(() => {
  fetchArtworkList();
});
</script>

<style scoped>
select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
</style>
